import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ApiRoutePathInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (request.url.indexOf('/director/api/v1/') === -1 && request.url.indexOf('/api/v1/customer-portal/') === -1 && request.url.indexOf('/api/v1/') !== -1) {
        let url = request.url.replace(/\/api\/v1\b/g, '/api/v1/customer-portal');
        while (url && url.lastIndexOf('/') === url.length - 1) {
            url = url.substring(0, url.length - 1);
        }

        if (url) {
            const clonedRequest = request.clone({
                url: url,
            });
            return next.handle(clonedRequest);
        }
    }

    return next.handle(request);
  }
}